export default {
  issue_update: "Only Supervisor or Manager has the permission to perform this action",
  no_access: "You do not have permission to perform this action",
  issue_in_work_order:
    "Issue is part of a Corrective Work Order and you do not have permission to update it",
  access_create: "Create",
  access_read: "Read",
  access_update: "Update",
  access_delete: "Delete",
  access_admin: "Access to Admin Panels",
  permission_attributes: "Attributes",
  permission_audit: "Audit",
  permission_change_approvals: "Change Approvals",
  permission_change_requests: "Change Requests",
  permission_organisations: "Organisations",
  permission_files: "Files",
  permission_gis: "GIS",
  permission_history: "History",
  permission_identifiers: "Identifiers",
  permission_issues: "Issues",
  permission_items: "Items",
  permission_license_accounts: "License Accounts",
  permission_oauth_apps: "Authentication Apps",
  permission_oauth_tokens: "Authentication Tokens",
  permission_performed_work: "Performed Work",
  permission_planning: "Planning",
  permission_procedures: "Procedures",
  permission_service_providers: "Service Providers",
  permission_springboard_admin_ui: "Springboard Admin UI",
  permission_user_accounts: "User Accounts",
  permission_user_roles: "User Roles",
  permission_user_settings: "User Settings",
  permission_vpc: "VPC",
  permission_workspaces: "Workspaces",
  permission_workspace_admin_ui: "Workspace Admin UI",
  permission_work_domains: "Work Domains",
  permission_work_orders: "Work Orders",
  one_or_more_issues: "One or more Issues are not closed due to lack of permissions",
  issue_close_no_permission: "You do not have permission to close this issue",
}
